import { createAction, props } from '@ngrx/store';

export const loadProductPrice = createAction(
  '[Product Price] Load',
  props<{ params: { customerId: number; productId: number; plantId: number }; key: string }>(),
);

export const loadProductPriceSuccess = createAction(
  '[Product Price] Load Success',
  props<{ key: string; data: any[] }>(),
);

export const loadProductPriceFailure = createAction(
  '[Product Price] Load Failure',
  props<{ key: string; error: string }>(),
);

export const clearProductPriceByKey = createAction('[Product Price] Clear By Key', props<{ key: string }>());
